import { notify } from '../../actions/notifications';
import { changeTitle } from '../../actions/savedSearches/actions';
import {
  TUpdateTitleSavedSearchDesktopResponse,
  fetchUpdateTitleSavedSearchDesktop,
} from '../../repositories/saved-searches/v1/update-title-saved-search-desktop';
import { ENotificationStyle } from '../../types/notifications';
import { TThunkAction } from '../../types/redux';

export interface IChangeTitleSavedSearchParameters {
  id: number;
  title: string;
}

export const changeTitleSavedSearch =
  ({ id, title }: IChangeTitleSavedSearchParameters): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    const showError = () =>
      dispatch(notify('Не удалось обновить название. Попробуйте повторить попытку позже', ENotificationStyle.Error));

    try {
      const { statusCode, response }: TUpdateTitleSavedSearchDesktopResponse = await fetchUpdateTitleSavedSearchDesktop(
        {
          httpApi,
          parameters: {
            savedSearchId: id,
            title,
          },
        },
      );

      if (statusCode === 200) {
        dispatch(changeTitle({ id, title }));
      }

      if (statusCode === 400) {
        showError();
        logger.warning(response.message || 'Failed change saved search title (400 status code)');
      }
    } catch (e) {
      showError();
      logger.error(e, { description: 'Failed change saved search title' });
    }
  };
